import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
import { Carousel } from './Carousel';
const floatingIcons = [{
  emoji: '🎉',
  top: '6%',
  left: '6%',
  size: 'text-3xl',
  delay: 0
}, {
  emoji: '🎈',
  top: '12%',
  right: '8%',
  size: 'text-4xl',
  delay: 0.6
}, {
  emoji: '🎀',
  top: '38%',
  left: '4%',
  size: 'text-2xl',
  delay: 1.2
}, {
  emoji: '🥂',
  top: '30%',
  right: '5%',
  size: 'text-3xl',
  delay: 0.9
}, {
  emoji: '🎂',
  bottom: '30%',
  left: '8%',
  size: 'text-2xl',
  delay: 1.5
}, {
  emoji: '🎊',
  bottom: '24%',
  right: '7%',
  size: 'text-3xl',
  delay: 0.3
}, {
  emoji: '💫',
  top: '54%',
  left: '46%',
  size: 'text-xl',
  delay: 1.1
}] as const;
export function Hero() {
  const images = [{
    src: 'https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?auto=format&fit=crop&q=80&w=800',
    label: 'Cumpleaños temático'
  }, {
    src: 'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&q=80&w=800',
    label: 'Casamiento íntimo'
  }, {
    src: 'https://images.unsplash.com/photo-1478146896981-b80fe463b330?auto=format&fit=crop&q=80&w=800',
    label: 'Mesa dulce'
  }, {
    src: 'https://images.unsplash.com/photo-1527529482837-4698179dc6ce?auto=format&fit=crop&q=80&w=800',
    label: 'Arco de globos'
  }, {
    src: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&q=80&w=800',
    label: 'Fiesta de adultos'
  }];
  return <section className="relative pt-8 pb-12 px-5 overflow-hidden flex flex-col items-center text-center" data-id="element-106">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#C9A24C 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-107"></div>

      {/* Festive floating background icons */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true" data-id="element-108">
        {floatingIcons.map((icon, idx) => <motion.span key={idx} className={`absolute ${icon.size} opacity-20 select-none`} style={{
        top: 'top' in icon ? icon.top : undefined,
        bottom: 'bottom' in icon ? icon.bottom : undefined,
        left: 'left' in icon ? icon.left : undefined,
        right: 'right' in icon ? icon.right : undefined
      }} animate={{
        y: [0, -12, 0],
        rotate: [0, 6, -6, 0]
      }} transition={{
        duration: 5 + idx * 0.4,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: icon.delay
      }} data-id="element-109">
            {icon.emoji}
          </motion.span>)}
      </div>

      <div className="relative z-10 w-full max-w-md mx-auto flex flex-col items-center" data-id="element-110">
        <div className="inline-flex items-center gap-2 bg-pink-pastel/30 text-wine px-4 py-1.5 rounded-full text-xs font-semibold mb-6 border border-pink-pastel" data-id="element-111">
          <span data-id="element-112">💕</span> De Amiga de las Fiestas a Experta que Cobra · Edición
          2026
        </div>

        <h1 className="text-3xl font-extrabold text-wine leading-tight mb-6" data-id="element-113">
          Deja de regalar tus decoraciones y empeza a ganar PLATA.
        </h1>

        <div className="w-full mb-6 relative" data-id="element-114">
          <motion.img src="https://cdn.magicpatterns.com/uploads/2XzqWnQrQJYcztmHzGtzLM/Untitled_design.png" alt="Decora Fácil PRO Mockup" className="w-full h-auto drop-shadow-2xl scale-110 origin-center" animate={{
          y: [0, -10, 0],
          rotate: [0, -0.8, 0.8, 0]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-115" />
        </div>

        <p className="text-[15px] text-dark/80 leading-[1.6] mb-8 px-2" data-id="element-116">
          El sistema completo para decorar, organizar y cobrar tus eventos como
          una profesional — y empezar a vivir de lo que amás.
        </p>

        <div className="w-full flex flex-col gap-3 mb-8" data-id="element-117">
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full h-[56px] bg-wine text-white rounded-xl font-bold text-lg flex items-center justify-center gap-2 shadow-lg shadow-wine/30 active:scale-[0.98] transition-transform" data-id="element-118">
            <span data-id="element-119">🎀</span> Quiero Decora Fácil PRO
          </button>
          <button onClick={() => document.getElementById('volumes')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full h-[56px] bg-transparent border-2 border-wine text-wine rounded-xl font-bold text-[15px] flex items-center justify-center active:bg-wine/5 transition-colors" data-id="element-120">
            Ver qué incluye ↓
          </button>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs font-medium text-dark/70 mb-10" data-id="element-121">
          <div className="flex items-center gap-1" data-id="element-122">
            <Star className="w-3.5 h-3.5 text-gold fill-gold" data-id="element-123" /> 4.9/5
          </div>
          <div className="flex items-center gap-1" data-id="element-124">
            · +900 mujeres ya lo tienen ·
          </div>
          <div className="flex items-center gap-1" data-id="element-125">6 tomos + 4 bonos</div>
          <div className="flex items-center gap-1" data-id="element-126">
            · <ShieldCheck className="w-3.5 h-3.5 text-sage" data-id="element-127" /> Garantía 7 días
          </div>
        </div>
      </div>

      {/* Horizontal Scroll Carousel */}
      <div className="w-full relative z-10 -mx-5 px-5" data-id="element-128">
        <Carousel images={images} theme="wine" slideWidthClass="w-[85%]" data-id="element-129" />
      </div>
    </section>;
}